import { mountDashboard } from "@autotracer/dashboard";
mountDashboard();